import { useMediaQuery } from "@/hooks";

import { CARGA_TRABALHO_MOBILE_QUERY } from "@/shared/components/gantt-carga/mobile";
import type { LegendSwatchKind } from "@/shared/components/legend-swatch";
import type { CargaLegendProps, CargaLegendViewModel } from "./types-carga-legend";

/** Mobile (Figma 9725:44279): só os itens de etapa; Cancelada e Indisponibilidade não são desenhadas. */
const ITENS_MOBILE = ["planejamento", "obra", "fechamento"];

/**
 * Legenda do Gantt de Profissionais. No mobile segue o Figma: Planejamento, Obra e Fechamento,
 * "Alterado na simulação" só quando há alterações (9725:353296) e Hoje, em 2 linhas.
 */
export function useCargaLegend({
  items,
  testId,
  simulando = false,
  alteracoes = 0,
  forPrint = false,
  simuladoPreenchido = false,
}: CargaLegendProps): CargaLegendViewModel {
  const mobile = useMediaQuery(CARGA_TRABALHO_MOBILE_QUERY);
  const visiveis =
    !forPrint && mobile ? items.filter((item) => ITENS_MOBILE.includes(item.key)) : items;

  return {
    testId,
    itens: visiveis.map((item) => ({ ...item, kind: item.key as LegendSwatchKind })),
    mostraSimulado: simulando && (forPrint || !mobile || alteracoes > 0),
    simuladoPreenchido,
  };
}
